// extracted by mini-css-extract-plugin
export default {"profilePhoto":"FZSVC6","noTitle":"MPJuUz"};